import { render } from "./TableRow.vue?vue&type=template&id=057ac563&ts=true"
import script from "./TableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057ac563"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057ac563', __exports__)) {
    api.reload('057ac563', __exports__)
  }
  
  module.hot.accept("./TableRow.vue?vue&type=template&id=057ac563&ts=true", () => {
    api.rerender('057ac563', render)
  })

}


export default __exports__